import {Stack} from "@mui/material";
import type {GeoFenceResolver} from "../../../../../../sdo/Resolver.ts";
import {MatchModeRow, F, SummaryPill, SummaryPillRow, rowSx, setNum, type ResolverEditorProps} from "./ResolverUtils.tsx";

function GeoFenceEditor({draft, editing, onChange}: ResolverEditorProps & { draft: GeoFenceResolver }) {
    if (!editing) {
        return (
            <Stack direction="column" spacing={0.5} sx={{alignItems: "center", width: "100%"}}>
                <SummaryPillRow>
                    <SummaryPill label="SW Latitude" value={draft.swLatitude}/>
                    <SummaryPill label="SW Longitude" value={draft.swLongitude}/>
                </SummaryPillRow>
                <SummaryPillRow>
                    <SummaryPill label="NE Latitude" value={draft.neLatitude}/>
                    <SummaryPill label="NE Longitude" value={draft.neLongitude}/>
                </SummaryPillRow>
            </Stack>
        );
    }

    const updNum = (key: string, raw: string) => setNum(draft, key, raw, onChange);
    return (
        <Stack direction="column" spacing={1} alignItems="center">
            <MatchModeRow draft={draft} editing={editing} onChange={onChange}/>
            <Stack direction="row" sx={rowSx}>
                <F value={draft.swLatitude} placeholder="SW Latitude" onChange={(v) => updNum("swLatitude", v)} width="150px"/>
                <F value={draft.swLongitude} placeholder="SW Longitude" onChange={(v) => updNum("swLongitude", v)} width="150px"/>
            </Stack>
            <Stack direction="row" sx={rowSx}>
                <F value={draft.neLatitude} placeholder="NE Latitude" onChange={(v) => updNum("neLatitude", v)} width="150px"/>
                <F value={draft.neLongitude} placeholder="NE Longitude" onChange={(v) => updNum("neLongitude", v)} width="150px"/>
            </Stack>
        </Stack>
    );
}

export default GeoFenceEditor;
